import React from 'react';
export function ProcessSteps() {
  const steps = [{
    number: '1',
    title: 'Revisión rápida del caso',
    description: 'Por WhatsApp o visita según necesidad. Evaluación profesional sin costo.'
  }, {
    number: '2',
    title: 'Ejecución del trabajo',
    description: 'Instalación, corrección o mantenimiento con ingenieros certificados.'
  }, {
    number: '3',
    title: 'Entrega y seguimiento',
    description: 'Certificación lista y seguimiento para que apruebes la inspección.'
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4" data-id="element-49">
            Cómo trabajamos
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-50">
            Proceso simple, rápido y profesional
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-51">
          {steps.map((step, index) => <div key={index} className="relative text-center" data-id="element-52">
              {/* Connector line (hidden on mobile) */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-1 bg-gradient-to-r from-jazugas-gold to-jazugas-blue" data-id="element-53"></div>}

              <div className="relative" data-id="element-54">
                <div className="w-24 h-24 bg-gradient-to-br from-jazugas-blue to-jazugas-blue/80 text-white rounded-2xl flex items-center justify-center text-4xl font-bold mx-auto mb-6 shadow-lg relative z-10" data-id="element-55">
                  {step.number}
                </div>
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 bg-jazugas-gold rounded-2xl opacity-20 blur-xl" data-id="element-56"></div>
              </div>

              <h3 className="text-2xl font-bold text-black mb-3" data-id="element-57">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-58">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}